import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Manage watchlist")
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "d-f f-xs c-tip py-4 mt-16" }, [
  /*#__PURE__*/_createVNode("span", { class: "flex-1 pl-32" }, "Asset"),
  /*#__PURE__*/_createVNode("p", {
    class: "df-between",
    style: {"width":"92px"}
  }, [
    /*#__PURE__*/_createVNode("span", null, "Top"),
    /*#__PURE__*/_createVNode("span", null, "Drag")
  ])
], -1)
const _hoisted_3 = { class: "fill df-middle pl-30" }
const _hoisted_4 = { class: "flex-1 t-left" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Select All")
const _hoisted_6 = { class: "flex-1 c-text" }
const _hoisted_7 = {
  key: 1,
  style: {"color":"var(--color-tip)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_TheEditListItem = _resolveComponent("TheEditListItem")
  const _component_List = _resolveComponent("List")
  const _component_Holder = _resolveComponent("Holder")
  const _component_Button = _resolveComponent("Button")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, { "use-footer": "" }, {
    title: _withCtx(() => [
      _createVNode(_component_t, { path: "market_8" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Checkbox, {
            onToggle: _ctx.toggleAll,
            checked: _ctx.isAllSelected
          }, {
            default: _withCtx(() => [
              _createVNode(_component_t, {
                path: "managewatchlist_2",
                class: "ml-16 c-text"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onToggle", "checked"])
        ]),
        _createVNode("span", _hoisted_6, [
          (_ctx.selectedCount)
            ? (_openBlock(), _createBlock("span", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
              }, [
                _createVNode(_component_t, { custom: "" }, {
                  default: _withCtx(({td, t}) => [
                    _createTextVNode(_toDisplayString(t('managewatchlist_3') || 'Remove'), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" (" + _toDisplayString(_ctx.selectedCount) + ") ", 1)
              ]))
            : (_openBlock(), _createBlock("span", _hoisted_7, [
                _createVNode(_component_t, { custom: "" }, {
                  default: _withCtx(({td, t}) => [
                    _createTextVNode(_toDisplayString(t('managewatchlist_3') || 'Remove'), 1)
                  ]),
                  _: 1
                })
              ]))
        ]),
        _createVNode(_component_Button, {
          class: "save primary text p-0",
          onClick: _ctx.save
        }, {
          default: _withCtx(() => [
            _createVNode(_component_t, {
              path: "managewatchlist_4",
              custom: ""
            }, {
              default: _withCtx(({td}) => [
                _createTextVNode(_toDisplayString(td || 'Save'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Holder, { content: _ctx.list }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_List, {
            identify: v => v.code,
            "list-data": _ctx.list,
            as: "div",
            "list-class": "sortable-watch__list"
          }, {
            default: _withCtx(({ index, item }) => [
              _createVNode(_component_TheEditListItem, {
                item: item,
                onToTop: _ctx.toTop
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Checkbox, {
                    class: "mr-16",
                    value: item.code,
                    modelValue: _ctx.selected,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected = $event))
                  }, null, 8, ["value", "modelValue"])
                ]),
                _: 2
              }, 1032, ["item", "onToTop"])
            ]),
            _: 1
          }, 8, ["identify", "list-data"])
        ]),
        _: 1
      }, 8, ["content"])
    ]),
    _: 1
  }))
}